import { useEffect } from "react";

export default function useOutsideClick(ref, callback, ignoreRef) {
    useEffect(() => {
        function handleClickOutside(event) {
            if ( ref.current && !ref.current.contains(event.target) && (!ignoreRef?.current || !ignoreRef.current.contains(event.target)) ) {
                callback();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback, ignoreRef]);
}